import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";

function UpdateScenario(props) {
  const navigate = useHistory();

  const [formData, setName] = useState({
    ScenarioName: "",
    Place: "",
    UserRole: "",

    CharacterName: "",
    DateOfBirth: "",
    Gender: "",
    CharacterRole: "",
    CharacterAddress: "",
    PersonalLife: "",
    CaseDescription: "",

    CharacterName1: "",
    DateOfBirth1: "",
    Gender1: "",
    CharacterRole1: "",
    CharacterAddress1: "",
    PersonalLife1: "",
    CaseDescription1: "",

    Skill1: "",
    SkillDesc1: "",
    Skill2: "",
    SkillDesc2: "",
    Skill3: "",
    SkillDesc3: "",
    Skill4: "",
    SkillDesc4: "",
    Skill5: "",
    SkillDesc5: "",
    Skill6: "",
    SkillDesc6: "",
    AboutTheCase: ""
  });
  const ManagID = localStorage.getItem("ManegerId");
  const SCENARIO_ID = localStorage.getItem("ScenarioId");

  const [ScenarioId, getScenarioId] = useState("");
  const [selectPortal, setselectPortal] = useState([]);
  const [EnvironmentList, setEnvironmentList] = useState([]);
  const [CharacterList, setCharacterList] = useState([]);
  const [CharacterList1, setCharacterList1] = useState([]);
  const [EnvironmentId, setEnvironmentId] = React.useState("");
  const [CharacterId, setCharacterId] = React.useState("");
  const [CharacterId1, setCharacterId1] = React.useState("");
  const [EnvironmentImgPreview, setEnvironmentImgPreview] = React.useState("");
  const [CharacterImgPreview, setCharacterImgPreview] = React.useState("");
  const [CharacterImgPreview1, setCharacterImgPreview1] = React.useState("");

  useEffect(() => {
    LoadScenario();
  }, []);

  const LoadScenario = () => {
    const datavalue = {
      scenarioId: SCENARIO_ID,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getScenarioByid`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      setName({
        ScenarioName: res.data.result.Scenario_Name,
        Place: res.data.result.Scenario_Location,
        UserRole: res.data.result.User_Role,

        CharacterName: res.data.result.Character_Name,
        DateOfBirth: res.data.result.Character_DOB,
        Gender: res.data.result.Character_Gender,
        CharacterRole: res.data.result.Character_Role,
        CharacterAddress: res.data.result.Character_Address,
        PersonalLife: res.data.result.Personal_Life,
        CaseDescription: res.data.result.Case_Description,

        CharacterName1: res.data.result.Character_Name1,
        DateOfBirth1: res.data.result.Character_DOB1,
        Gender1: res.data.result.Character_Gender1,
        CharacterRole1: res.data.result.Character_Role1,
        CharacterAddress1: res.data.result.Character_Address1,
        PersonalLife1: res.data.result.Personal_Life1,
        CaseDescription1: res.data.result.Case_Description1,

        AboutTheCase: res.data.result.About_The_Case,
        Skill1: res.data.result.Skill1,
        Skill2: res.data.result.Skill2,
        Skill3: res.data.result.Skill3,
        Skill4: res.data.result.Skill4,
        Skill5: res.data.result.Skill5,
        // Skill6: res.data.result.Skill6,
        Skill6: "",
        SkillDesc1: res.data.result.SkillDesc1,
        SkillDesc2: res.data.result.SkillDesc2,
        SkillDesc3: res.data.result.SkillDesc3,
        SkillDesc4: res.data.result.SkillDesc4,
        SkillDesc5: res.data.result.SkillDesc5,
        // SkillDesc6: res.data.result.SkillDesc6,
        SkillDesc6: "",
      });
      getScenarioId(res.data.result.Scenario_Id);
      setselectPortal(res.data.result.Portal_Id);

      setEnvironmentId(res.data.result.Environment_Id);
      setCharacterId(res.data.result.Character_Id);
      setCharacterId1(res.data.result.Character_Id1);
      LoadEnvironmentImg(res.data.result.Environment_Id);
      LoadCharacterImg(res.data.result.Character_Id);
      LoadCharacterImg1(res.data.result.Character_Id1);

      LoadEnvironments(res.data.result.Portal_Id);
      LoadCharacters(res.data.result.Portal_Id);
    });
  };

  const LoadEnvironments = (portalId) => {
    const datavalue = {
      portalId: portalId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetScenarioEnvByPortal`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      setEnvironmentList(res.data.data);
    });
  };

  const LoadCharacters = (portalId) => {
    const datavalue = {
      portalId: portalId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetCharacterByPortal`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      setCharacterList(res.data.data);
      setCharacterList1(res.data.data);
    });
  };

  const handleChangeEnvironment = (event) => {
    let env_id = event.target.value
    setEnvironmentId(env_id);
    LoadEnvironmentImg(env_id);
  };

  function LoadEnvironmentImg(env_id) {
    if (env_id != "") {
      var imagepath = `${process.env.REACT_APP_API_URL}/GetScenarioEnvImageById?EnvironmentId=` + env_id;
      setEnvironmentImgPreview(imagepath);
      var img = document.getElementById("envImgPreview")
      img.style.visibility = "visible";
      img.style.width = "100%";
      // img.style.maxHeight = "150px";
      img.style.height = "auto";
    } else {
      var img = document.getElementById("envImgPreview");
      img.style.visibility = "hidden";
      img.style.width = "0px";
      img.style.height = "0px";
    }
  }

  const handleChangeCharacter = (event) => {
    let character_id = event.target.value
    setCharacterId(character_id);
    LoadCharacterImg(character_id);
  };

  const handleChangeCharacter1 = (event) => {
    let character_id = event.target.value
    setCharacterId1(character_id);
    LoadCharacterImg1(character_id);
  };

  function LoadCharacterImg(character_id) {
    if (character_id != "") {
      var imagepath = `${process.env.REACT_APP_API_URL}/GetCharacterImageById?CharacterId=` + character_id;
      setCharacterImgPreview(imagepath);
      var img = document.getElementById("characterImgPreview");
      img.style.visibility = "visible";
      img.style.width = "100%";
      // img.style.maxHeight = "150px";
      img.style.height = "auto";
    } else {
      var img = document.getElementById("characterImgPreview");
      img.style.visibility = "hidden";
      img.style.width = "0px";
      img.style.height = "0px";
    }
  }

  function LoadCharacterImg1(character_id) {
    if (character_id != "") {
      var imagepath = `${process.env.REACT_APP_API_URL}/GetCharacterImageById?CharacterId=` + character_id;
      setCharacterImgPreview1(imagepath);
      var img = document.getElementById("characterImgPreview1");
      img.style.visibility = "visible";
      img.style.width = "100%";
      img.style.height = "auto";
    } else {
      var img = document.getElementById("characterImgPreview1");
      img.style.visibility = "hidden";
      img.style.width = "0px";
      img.style.height = "0px";
    }
  }

  const ScenarioSubmit = async (e) => {
    e.preventDefault();
    let formDataSet = new FormData();

    if (
      selectPortal == "" ||
      formData.ScenarioName === "" ||
      formData.Place === "" ||
      formData.UserRole === "" ||
      EnvironmentId === "" ||

      formData.CharacterName === "" ||
      formData.DateOfBirth === "" ||
      formData.Gender === "" ||
      formData.CharacterRole === "" ||
      formData.CharacterAddress === "" ||
      formData.PersonalLife === "" ||
      formData.CaseDescription === "" ||
      CharacterId === "" ||

      formData.CharacterName1 === "" ||
      formData.DateOfBirth1 === "" ||
      formData.Gender1 === "" ||
      formData.CharacterRole1 === "" ||
      formData.CharacterAddress1 === "" ||
      formData.PersonalLife1 === "" ||
      formData.CaseDescription1 === "" ||
      CharacterId1 === ""
    ) {
      if (selectPortal === "") {
        Swal.fire({
          title: "Error",
          text: "Please Select Portal",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.ScenarioName === "") {
        Swal.fire({
          title: "Error",
          text: "Scenario Name is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.Place === "") {
        Swal.fire({
          title: "Error",
          text: "Scenario Location is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.UserRole === "") {
        Swal.fire({
          title: "Error",
          text: "User's Role is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (EnvironmentId === "") {
        Swal.fire({
          title: "Error",
          text: "Please select Environment",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }

      if (formData.CharacterName === "") {
        Swal.fire({
          title: "Error",
          text: "Character Name is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.DateOfBirth === "") {
        Swal.fire({
          title: "Error",
          text: "Character's DOB is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.Gender === "") {
        Swal.fire({
          title: "Error",
          text: "Select Geder",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.CharacterRole === "") {
        Swal.fire({
          title: "Error",
          text: "Character Role is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.CharacterAddress === "") {
        Swal.fire({
          title: "Error",
          text: "Character Address is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.PersonalLife === "") {
        Swal.fire({
          title: "Error",
          text: "Enter Character's Personal Life",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.CaseDescription === "") {
        Swal.fire({
          title: "Error",
          text: "Case Description is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (CharacterId === "") {
        Swal.fire({
          title: "Error",
          text: "Please select Character",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }

      if (formData.CharacterName1 === "") {
        Swal.fire({
          title: "Error",
          text: "Character Name is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.DateOfBirth1 === "") {
        Swal.fire({
          title: "Error",
          text: "Character's DOB is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.Gender1 === "") {
        Swal.fire({
          title: "Error",
          text: "Select Geder",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.CharacterRole1 === "") {
        Swal.fire({
          title: "Error",
          text: "Character Role is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.CharacterAddress1 === "") {
        Swal.fire({
          title: "Error",
          text: "Character Address is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.PersonalLife1 === "") {
        Swal.fire({
          title: "Error",
          text: "Enter Character's Personal Life",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (formData.CaseDescription1 === "") {
        Swal.fire({
          title: "Error",
          text: "Case Description is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      if (CharacterId1 === "") {
        Swal.fire({
          title: "Error",
          text: "Please select Character",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    } else {
      formDataSet.append("Id", SCENARIO_ID);
      formDataSet.append("Scenario_Id", ScenarioId);
      formDataSet.append("Manager_Id", ManagID);
      formDataSet.append("Portal_Id", selectPortal);
      formDataSet.append("Scenario_Name", formData.ScenarioName.charAt(0).toUpperCase() + formData.ScenarioName.slice(1));
      formDataSet.append("Scenario_Location", formData.Place.charAt(0).toUpperCase() + formData.Place.slice(1));
      formDataSet.append("User_Role", formData.UserRole.charAt(0).toUpperCase() + formData.UserRole.slice(1));
      formDataSet.append("Environment_Id", EnvironmentId);

      formDataSet.append("Character_Name", formData.CharacterName.charAt(0).toUpperCase() + formData.CharacterName.slice(1));
      formDataSet.append("Character_DOB", formData.DateOfBirth);
      formDataSet.append("Character_Gender", formData.Gender);
      formDataSet.append("Character_Role", formData.CharacterRole.charAt(0).toUpperCase() + formData.CharacterRole.slice(1));
      formDataSet.append("Character_Address", formData.CharacterAddress.charAt(0).toUpperCase() + formData.CharacterAddress.slice(1));
      formDataSet.append("Personal_Life", formData.PersonalLife.charAt(0).toUpperCase() + formData.PersonalLife.slice(1));
      formDataSet.append("Case_Description", formData.CaseDescription.charAt(0).toUpperCase() + formData.CaseDescription.slice(1));
      formDataSet.append("Character_Id", CharacterId);

      formDataSet.append("Character_Name1", formData.CharacterName1.charAt(0).toUpperCase() + formData.CharacterName1.slice(1));
      formDataSet.append("Character_DOB1", formData.DateOfBirth1);
      formDataSet.append("Character_Gender1", formData.Gender1);
      formDataSet.append("Character_Role1", formData.CharacterRole1.charAt(0).toUpperCase() + formData.CharacterRole1.slice(1));
      formDataSet.append("Character_Address1", formData.CharacterAddress1.charAt(0).toUpperCase() + formData.CharacterAddress1.slice(1));
      formDataSet.append("Personal_Life1", formData.PersonalLife1.charAt(0).toUpperCase() + formData.PersonalLife1.slice(1));
      formDataSet.append("Case_Description1", formData.CaseDescription1.charAt(0).toUpperCase() + formData.CaseDescription1.slice(1));
      formDataSet.append("Character_Id1", CharacterId1);

      formDataSet.append("About_The_Case", formData.AboutTheCase.charAt(0).toUpperCase() + formData.AboutTheCase.slice(1));
      formDataSet.append("Skill1", formData.Skill1 ? formData.Skill1 : "");
      formDataSet.append("Skill2", formData.Skill2 ? formData.Skill2 : "");
      formDataSet.append("Skill3", formData.Skill3 ? formData.Skill3 : "");
      formDataSet.append("Skill4", formData.Skill4 ? formData.Skill4 : "");
      formDataSet.append("Skill5", formData.Skill5 ? formData.Skill5 : "");
      // formDataSet.append("Skill6", formData.Skill6 ? formData.Skill6 : "");
      formDataSet.append("Skill6", "");
      formDataSet.append("SkillDesc1", formData.SkillDesc1 ? formData.SkillDesc1 : "");
      formDataSet.append("SkillDesc2", formData.SkillDesc2 ? formData.SkillDesc2 : "");
      formDataSet.append("SkillDesc3", formData.SkillDesc3 ? formData.SkillDesc3 : "");
      formDataSet.append("SkillDesc4", formData.SkillDesc4 ? formData.SkillDesc4 : "");
      formDataSet.append("SkillDesc5", formData.SkillDesc5 ? formData.SkillDesc5 : "");
      // formDataSet.append("SkillDesc6", formData.SkillDesc6 ? formData.SkillDesc6 : "");
      formDataSet.append("SkillDesc6", "");

      // Extract token from localStorage.state
      let token = null;
      try {
        const raw = localStorage.getItem("state");
        if (raw) {
          const state = JSON.parse(raw);
          token = state.auth?.token;
        }
      } catch (e) {
        console.error("Token parsing failed", e);
      }

      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/updateScenarioByid`,
        data: formDataSet,
        headers: { "content-type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
      };
      axios(authOptions)
        .then((res) => {
          if (res.data.ExpResult) {
            Swal.fire({
              title: "Error",
              text: res.data.ExpResult,
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1e2b38"
            });
          } else if (res.data.SuccessResult) {
            Swal.fire({
              title: "Success",
              text: res.data.SuccessResult,
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1e2b38"
            }).then(function () {
              navigate.push("/ScenarioList");
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "Something unexpected occured!",
              icon: "error",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch((error) => {
          //console.log("error occur", error);
        });
    }
  };

  const BackFunc = () => {
    navigate.push("/ScenarioList")

    // UserRole === "Admin"
    //   ? navigate.push("/ScenarioList")
    //   : navigate.push("/ManagerPatientList");
  };

  // const handleChangeDrp = (event) => {
  //   setGender(event.target.value);
  // };

  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">Update Multicharacter Simulation</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block btn-primary"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-2 col-sm-2"></div>
            <div className="col-md-8 col-sm-8">
              <div className="card card-box">
                <div className="card-head d-none">
                  <header>Update Scenario</header>
                </div>
                <div className="card-body " id="bar-parent1">
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={ScenarioSubmit}
                  >
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Scenario ID
                      </label>
                      <div className="col-sm-9 pt-3">
                        <span>{ScenarioId}</span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Portal Id
                      </label>
                      <div className="col-sm-9 pt-3">
                        <span className="mt-2">{selectPortal}</span>
                      </div>
                    </div>

                    {/* Scenario Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="ScenarioName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Scenario Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.ScenarioName}
                          onChange={handleChange}
                          name="ScenarioName"
                          className="form-control"
                          id="ScenarioName"
                          placeholder="Enter the name of your scenario"
                        />
                      </div>
                    </div>

                    {/* Place of Occurrence / Scenario location */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Place"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Scenario location
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.Place}
                          onChange={handleChange}
                          name="Place"
                          className="form-control"
                          id="Place"
                          placeholder="Enter the location where the scenario is being taking place "
                        />
                      </div>
                    </div>

                    {/* User Role */}
                    <div className="form-group row required">
                      <label
                        htmlFor="UserRole"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        User's Role
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.UserRole}
                          onChange={handleChange}
                          name="UserRole"
                          className="form-control"
                          id="UserRole"
                          placeholder="Enter the role of the user/learner "
                        />
                      </div>
                    </div>

                    {/* Environment Image */}
                    <div className="form-group row required">
                      <label
                        htmlFor="environment"
                        className="col-sm-3 control-label"
                      >
                        Environment
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="environment"
                          className="form-control select2"
                          onChange={handleChangeEnvironment}
                        >
                          <option value="">--Select--</option>
                          {EnvironmentList.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id} selected={result.id == EnvironmentId ? true : false}>
                                {result.environment_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col-sm-5">
                        <div className="col-sm-12 d-flex justify-content-center">
                          <a href={EnvironmentImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                              id="envImgPreview"
                              className="previewImg"
                              src={EnvironmentImgPreview}
                              style={{
                                objectFit: "contain",
                                visibility: "hidden"
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Case One (1) Starts */}

                    <div style={{ margin: "50px 0 20px 0" }}>
                      <h5 style={{ letterSpacing: "1px", fontSize: "14px", fontWeight: "700", margin: "0", padding: "0" }}>Add Case 1</h5>
                      <hr style={{ height: "2px", color: "#000" }} />
                    </div>


                    {/* Character Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterName}
                          onChange={handleChange}
                          name="CharacterName"
                          className="form-control"
                          id="CharacterName"
                          placeholder="Enter the name of your virtual character "
                        />
                      </div>
                    </div>

                    {/* Character Date of Birth */}
                    <div className="form-group row required">
                      <label
                        htmlFor="DateOfBirth"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Date of Birth
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="date"
                          value={formData.DateOfBirth}
                          onChange={handleChange}
                          name="DateOfBirth"
                          className="form-control"
                          id="DateOfBirth"
                          max={new Date()?.toISOString()?.slice(0, 10)}
                          placeholder="Enter DOB"
                        />
                      </div>
                    </div>

                    {/* Gender */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Gender"
                        className="col-sm-3 control-label"
                      >
                        Gender
                      </label>
                      <div className="col-sm-9">
                        <select
                          id="Gender"
                          className="form-control  select2"
                          name="Gender"
                          value={formData.Gender}
                          onChange={handleChange}
                        >
                          <option value="">Select the gender of the virtual character </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="NonBinary">Non Binary</option>
                        </select>
                      </div>
                    </div>

                    {/* Character Role */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterRole"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character's Role
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterRole}
                          onChange={handleChange}
                          name="CharacterRole"
                          className="form-control"
                          id="CharacterRole"
                          placeholder="Enter the role of the virtual character "
                        />
                      </div>
                    </div>

                    {/* Character Address */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterAddress"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Address
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterAddress}
                          onChange={handleChange}
                          name="CharacterAddress"
                          className="form-control"
                          id="CharacterAddress"
                          placeholder="Enter the residential address of the virtual character "
                        />
                      </div>
                    </div>

                    {/* Personal Life */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PersonalLife"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Virtual Character's Personal Life
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          value={formData.PersonalLife}
                          onChange={handleChange}
                          name="PersonalLife"
                          className="form-control"
                          id="PersonalLife"
                          style={{ width: "100%", height: "100px" }}
                          placeholder="Enter details about the virtual character’s personal life, e.g., married, children, occupation, family members etc "
                        />
                      </div>
                    </div>

                    {/* Case Description */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CaseDescription"
                        className="col-sm-3 control-label"
                      >
                        Case Description
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          id="CaseDescription"
                          className="form-control"
                          name="CaseDescription"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.CaseDescription}
                          onChange={handleChange}
                          placeholder="Enter details about the case, e.g., what is the issue, what is the problem, what is the subject of conversation. "
                        />
                      </div>
                    </div>

                    {/* Character Image */}
                    <div className="form-group row required">
                      <label
                        htmlFor="character"
                        className="col-sm-3 control-label"
                      >
                        Character
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="character"
                          className="form-control select2"
                          onChange={handleChangeCharacter}
                        >
                          <option value="">--Select--</option>
                          {CharacterList.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id} selected={result.id == CharacterId ? true : false}>
                                {result.character_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-sm-5">
                        <div className="col-sm-12 d-flex justify-content-center">
                          <a href={CharacterImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                              id="characterImgPreview"
                              className="previewImg"
                              src={CharacterImgPreview}
                              style={{
                                objectFit: "contain",
                                visibility: "hidden",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Case Two (2) Starts */}

                    <div style={{ margin: "50px 0 20px 0" }}>
                      <h5 style={{ letterSpacing: "1px", fontSize: "14px", fontWeight: "700", margin: "0", padding: "0" }}>Add Case 2</h5>
                      <hr style={{ height: "2px", color: "#000" }} />
                    </div>

                    {/* Character 1 Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterName1"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterName1}
                          onChange={handleChange}
                          name="CharacterName1"
                          className="form-control"
                          id="CharacterName1"
                          placeholder="Enter the name of your virtual character "
                        />
                      </div>
                    </div>

                    {/* Character Date of Birth */}
                    <div className="form-group row required">
                      <label
                        htmlFor="DateOfBirth1"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Date of Birth
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="date"
                          value={formData.DateOfBirth1}
                          onChange={handleChange}
                          name="DateOfBirth1"
                          className="form-control"
                          id="DateOfBirth1"
                          max={new Date()?.toISOString()?.slice(0, 10)}
                          placeholder="Enter DOB"
                        />
                      </div>
                    </div>

                    {/* Gender */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Gender1"
                        className="col-sm-3 control-label"
                      >
                        Gender
                      </label>
                      <div className="col-sm-9">
                        <select
                          id="Gender1"
                          className="form-control  select2"
                          name="Gender1"
                          value={formData.Gender1}
                          onChange={handleChange}
                        >
                          <option value="">Select the gender of the virtual character </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="NonBinary">Non Binary</option>
                        </select>
                      </div>
                    </div>

                    {/* Character Role */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterRole1"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character's Role
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterRole1}
                          onChange={handleChange}
                          name="CharacterRole1"
                          className="form-control"
                          id="CharacterRole1"
                          placeholder="Enter the role of the virtual character "
                        />
                      </div>
                    </div>

                    {/* Character Address */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterAddress1"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Address
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterAddress1}
                          onChange={handleChange}
                          name="CharacterAddress1"
                          className="form-control"
                          id="CharacterAddress1"
                          placeholder="Enter the residential address of the virtual character "
                        />
                      </div>
                    </div>

                    {/* Personal Life */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PersonalLife1"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Virtual Character's Personal Life
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          value={formData.PersonalLife1}
                          onChange={handleChange}
                          name="PersonalLife1"
                          className="form-control"
                          id="PersonalLife1"
                          style={{ width: "100%", height: "100px" }}
                          placeholder="Enter details about the virtual character’s personal life, e.g., married, children, occupation, family members etc "
                        />
                      </div>
                    </div>

                    {/* Case Description */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CaseDescription1"
                        className="col-sm-3 control-label"
                      >
                        Case Description
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          id="CaseDescription1"
                          className="form-control"
                          name="CaseDescription1"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.CaseDescription1}
                          onChange={handleChange}
                          placeholder="Enter details about the case, e.g., what is the issue, what is the problem, what is the subject of conversation. "
                        />
                      </div>
                    </div>

                    {/* Character 1 Image */}
                    <div className="form-group row required">
                      <label
                        htmlFor="character1"
                        className="col-sm-3 control-label"
                      >
                        Character
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="character1"
                          className="form-control select2"
                          onChange={handleChangeCharacter1}
                        >
                          <option value="">--Select--</option>
                          {CharacterList1.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id} selected={result.id == CharacterId1 ? true : false}>
                                {result.character_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-sm-5">
                        <div className="col-sm-12 d-flex justify-content-center">
                          <a href={CharacterImgPreview1} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                              id="characterImgPreview1"
                              className="previewImg"
                              src={CharacterImgPreview1}
                              style={{
                                objectFit: "contain",
                                visibility: "hidden",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    <hr style={{ height: "2px", color: "#000", marginTop: "30px", marginBottom: "10px" }} />
                    <h4 style={{ textAlign: "center", marginTop: "0", marginBottom: "20px", fontWeight: "800" }}>Additional Details</h4>

                    {/* Assessment Blueprint */}
                    <div className="form-group row required">
                      <label
                        htmlFor="assessmentBlueprint"
                        className="col-sm-3 control-label"
                      >
                        Assessment Blueprint
                      </label>
                      <div className="col-sm-9">
                        <div className="row">
                          <div className="col-sm-4">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill1" value={formData.Skill1} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc1" className="form-control" value={formData.SkillDesc1} onChange={handleChange} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill2" value={formData.Skill2} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc2" className="form-control" value={formData.SkillDesc2} onChange={handleChange} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill3" value={formData.Skill3} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc3" className="form-control" value={formData.SkillDesc3} onChange={handleChange} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill4" value={formData.Skill4} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc4" className="form-control" value={formData.SkillDesc4} onChange={handleChange} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill5" value={formData.Skill5} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc5" className="form-control" value={formData.SkillDesc5} onChange={handleChange} />
                          </div>

                          <div className="col-sm-4 mt-3 d-none">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill6" value={formData.Skill6} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8 mt-3 d-none">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc6" className="form-control" value={formData.SkillDesc6} onChange={handleChange} />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* About The Case */}
                    <div className="form-group row required">
                      <label
                        htmlFor="AboutTheCase"
                        className="col-sm-3 control-label"
                      >
                        About The Case
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          id="AboutTheCase"
                          className="form-control"
                          name="AboutTheCase"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.AboutTheCase}
                          onChange={handleChange}
                          placeholder="About the case ... "
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 text-end">
                        <button
                          type="submit"
                          className="btn d-inline-block btn-primary"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateScenario;
